import React, { useState } from "react";
import { Container, Row, Col, Card, CardHeader, CardBody, Nav, NavItem, NavLink, TabContent, TabPane } from "reactstrap";
import { Breadcrumbs } from "../../../../AbstractElements";
import BannerManagement from "./PageComponents/BannerManagement";

const MarketingManagement = () => {
  const [activeTab, setActiveTab] = useState("banners");

  return (
    <Container fluid={true}>
      <Breadcrumbs mainTitle="Marketing Management" parent="Marketing" title="Manage Campaigns & Banners" />
      <Row>
        <Col xl="12">
          <Card>
            {/* <CardHeader>
              <Nav tabs>
                <NavItem>
                  <NavLink className={activeTab === "campaigns" ? "active" : ""} onClick={() => setActiveTab("campaigns")}>
                    Campaigns
                  </NavLink>
                </NavItem>
                <NavItem>
                  <NavLink className={activeTab === "banners" ? "active" : ""} onClick={() => setActiveTab("banners")}>
                    Banners
                  </NavLink>
                </NavItem>
              </Nav>
            </CardHeader> */}
            <CardBody>
              <TabContent activeTab={activeTab}>
                {/* <TabPane tabId="campaigns">
                  <CampaignManagement />
                </TabPane> */}
                <TabPane tabId="banners">
                  <BannerManagement />
                </TabPane>
              </TabContent>
            </CardBody>
          </Card>
        </Col>
      </Row>
    </Container>
  );
};

export default MarketingManagement;